import { roundedFormHeader, panelRounded } from "theme/styles/mixins";

export default `
  .form-section-label {
    ${roundedFormHeader}
    ${panelRounded}
    background-color: var(--box-medium-bg-color);

    .backend & {
      background-color: var(--box-bg-color);
    }
  }
`;
